import { render, staticRenderFns } from "./order-address.vue?vue&type=template&id=0e53d48a&scoped=true"
import script from "./order-address.vue?vue&type=script&lang=js"
export * from "./order-address.vue?vue&type=script&lang=js"
import style0 from "./order-address.vue?vue&type=style&index=0&id=0e53d48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53d48a",
  null
  
)

export default component.exports